import { LeaveManagerApiDTO_LeaveApplication } from '../../Components/LeaveManager/LeaveApplicationForm'
import { getBaseQuery, getBaseUrl } from '../../Utils'
import { createApi } from '@reduxjs/toolkit/query/react'
import APIHelper from '../HelperMethodsForAPI'
import Cookies from 'js-cookie'
import { FoundationsConstants } from '../../FoundationsConstants'

const baseUrl = `${getBaseUrl()}API/v3/FORMENGINE`

export const FormsEngineConfig = createApi({
    reducerPath: 'FormsEngineConfig',
    baseQuery: getBaseQuery(baseUrl),
    endpoints: (builder) => ({
        
        GetCurrentForms: builder.mutation<any, {location:string}>({
            query: (arg) => {
                const {location} = arg
                const hl_user_token = Cookies.get(FoundationsConstants.TOKEN_STR)

                return {
                    url: 'GetCurrentForms',
                    params: { location: location },
                    method: 'GET',
                    headers: { 'hl-user-token': hl_user_token, }
                }
            },
            transformResponse: (response: any) => {
                return response.data ? response.data : []
            },
        }),

        GenerateSchema: builder.mutation<any, void>({
            query: () => {
                const hl_user_token = Cookies.get(FoundationsConstants.TOKEN_STR)
                return {
                    url: 'GenerateFormSchemas',
                    headers: { 'hl-user-token': hl_user_token, },
                    method: 'GET',
                }
            },
            transformResponse: (response: any) => {
                return response.data ? response.data : []
            },
        }),

        ClearFormFieldCache: builder.mutation<any, void>({
            query: () => {
                const hl_user_token = Cookies.get(FoundationsConstants.TOKEN_STR)
                return {
                    url: `ClearFormFieldCache`,
                    headers: { 'hl-user-token': hl_user_token, },
                    method: 'GET',
                }
            },
        }),
    }),
})

export const {
    useGetCurrentFormsMutation,
    useGenerateSchemaMutation,
    useClearFormFieldCacheMutation
} = FormsEngineConfig